import { SVGProps } from 'react';
const SvgCrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 21v-3M6 6H3M6 3v15h15M18 14V6h-8"
    />
  </svg>
);
export default SvgCrop;
